import { createReducer, on } from '@ngrx/store';
import { quizActions } from '../actions/quiz.actions';
import { Quiz } from '../models';

interface QuizEntry {
    loaded: boolean | null;
    loading: boolean;
    quiz: Quiz | null;
    error: number | null;
}

export interface QuizState {
    saving: boolean;
    saved: boolean;
    createdId: string | null;
    entries: Record<string, QuizEntry>;
}

export const initialState: QuizState = {
    saving: false,
    saved: false,
    createdId: null,
    entries: {},
};

export const quizReducer = createReducer(
    initialState,
    // Get
    on(quizActions.getQuiz, (state, { id }): QuizState => ({
        ...state,
        entries: {
            ...state.entries,
            [id]: { loaded: null, loading: true, quiz: null, error: null },
        },
    })),
    on(quizActions.getQuizSuccess, (state, { payload }): QuizState => ({
        ...state,
        entries: {
            ...state.entries,
            [payload.id]: { loaded: true, loading: false, quiz: payload, error: null },
        },
    })),
    on(quizActions.getQuizError, (state, { id, code }): QuizState => ({
        ...state,
        entries: {
            ...state.entries,
            [id]: { loaded: false, loading: false, quiz: null, error: code },
        },
    })),
    // Create
    on(quizActions.createQuiz, (state): QuizState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(quizActions.createQuizSuccess, (state, { payload }): QuizState => ({
        ...state,
        saving: false,
        saved: true,
        createdId: payload.id,
        entries: {
            ...state.entries,
            [payload.id]: { loaded: true, loading: false, quiz: payload, error: null },
        },
    })),
    on(quizActions.createQuizError, (state): QuizState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Update
    on(quizActions.updateQuiz, (state): QuizState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(quizActions.updateQuizSuccess, (state, { payload }): QuizState => ({
        ...state,
        saving: false,
        saved: true,
        entries: {
            ...state.entries,
            [payload.id]: { loaded: true, loading: false, quiz: payload, error: null },
        },
    })),
    on(quizActions.updateQuizError, (state): QuizState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Delete
    on(quizActions.deleteQuiz, (state): QuizState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(quizActions.deleteQuizSuccess, (state, { id }): QuizState => {
        const quizEntries = { ...state.entries };
        delete quizEntries[id];

        return {
            ...state,
            saving: false,
            saved: true,
            entries: quizEntries,
        };
    }),
    on(quizActions.deleteQuizError, (state): QuizState => ({
        ...state,
        saving: false,
        saved: false,
    })),
    // Clear
    on(quizActions.clear, (): QuizState => ({ ...initialState })),
);
